import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .sheet-inner {
    background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
  }
`;

export const TitleBox = styled.div`
  ${({ theme }) => css`
    display: block;

    strong {
      display: block;
      ${theme.fontStyle.text.body18_medium}
      color: ${theme.content.content_light_1};
    }
  `}
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: block;

    p {
      display: block;
      ${theme.fontStyle.text.body14_medium}
      color: ${theme.content.content_light_3};
      word-break: keep-all;
    }
  `}
`;
